import React, { Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import { PrimeReactProvider } from 'primereact/api'
import Tailwind from 'primereact/passthrough/tailwind'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import './assets/scss/index.scss'
import './assets/scss/app.css'
import { persistor, store } from './redux/store'
import App from './App'
import reportWebVitals from './reportWebVitals'
import ErrorBoundary from './shared/ErrorBoundary'
import ErrorBoundaryAlert from './shared/ErrorBoundaryAlert'
import ToasterComponent from './helpers/Toaster'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <ErrorBoundary fallback={ErrorBoundaryAlert}>
    <Suspense fallback={null}>
      <PrimeReactProvider value={{
        //unstyled: false,
        pt: Tailwind
      }}>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <App />
          </PersistGate>
        </Provider>
        <ToasterComponent />
      </PrimeReactProvider>
    </Suspense>
  </ErrorBoundary>
)

reportWebVitals()
